export var Domain;
(function (Domain) {
    Domain["AddressPrediction"] = "AddressPrediction";
    Domain["Availability"] = "Availability";
    Domain["BankAccount"] = "BankAccount";
    Domain["Billing"] = "Billing";
    Domain["Consent"] = "Consent";
    Domain["ForwardGeocodedAddress"] = "ForwardGeocodedAddress";
    Domain["Gate"] = "Gate";
    Domain["OwnedParking"] = "OwnedParking";
    Domain["OwnedParkingImage"] = "OwnedParkingImage";
    Domain["OwnedParkingPriceRule"] = "OwnedParkingPriceRule";
    Domain["OwnedParkingSpot"] = "OwnedParkingSpot";
    Domain["Parking"] = "Parking";
    Domain["ParkingExistenceAtLocation"] = "ParkingExistenceAtLocation";
    Domain["ParkingForRegistrationNumberCheck"] = "ParkingForRegistrationNumberCheck";
    Domain["ParkingPath"] = "ParkingPath";
    Domain["ParkingVehicle"] = "ParkingVehicle";
    Domain["ParkingValidation"] = "ParkingValidation";
    Domain["PartialParking"] = "PartialParking";
    Domain["Payment"] = "Payment";
    Domain["PaynowClause"] = "PaynowClause";
    Domain["Pilot"] = "Pilot";
    Domain["Price"] = "Price";
    Domain["Reservation"] = "Reservation";
    Domain["ReservationSpanPaymentLink"] = "ReservationSpanPaymentLink";
    Domain["Ticket"] = "Ticket";
    Domain["UnauthorizedUseCase"] = "UnauthorizedUseCase";
    Domain["Unavailability"] = "Unavailability";
    Domain["UnavailabilityDay"] = "UnavailabilityDay";
    Domain["ReverseGeocodedAddress"] = "ReverseGeocodedAddress";
    Domain["Sign"] = "Sign";
    Domain["User"] = "User";
    Domain["Vehicle"] = "Vehicle";
    Domain["Wallet"] = "Wallet";
})(Domain || (Domain = {}));
export var ParkTimeContractType;
(function (ParkTimeContractType) {
    ParkTimeContractType["FixedDuration"] = "FixedDuration";
    ParkTimeContractType["FixedEnd"] = "FixedEnd";
})(ParkTimeContractType || (ParkTimeContractType = {}));
